module.exports = __webpack_public_path__ + "img/lib_prod.654bee8d.png";